import { instance } from 'solid-fetch'

export const ManageFetch = instance()

ManageFetch.setConfig({
  globalHeaders: {
    Authorization: (p) => `Bearer ${p.token}`,
  },
})
